import { createSelector, createFeatureSelector } from '@ngrx/store';
import { SpecializationState } from './state';
import {
  OccupationCategory,
  Specialization,
} from '@hrra/common-models';
import { JobseekerStoreState } from '../state';

const specializationState = createFeatureSelector<JobseekerStoreState>('jobseeker');


export const selectSpecializations = createSelector(
  specializationState,
  (s) => s.specialization.specializations
);

export const selectHeadSpecializations = createSelector(selectSpecializations, (s) =>
  s.filter((c) => c.head?.specializationId === null)
);

export const selectChildSpecializations = createSelector(selectSpecializations, (s) =>
  s.filter((c) => c.head?.specializationId !== null)
);

export const selectSpecializationsMap = createSelector(selectSpecializations, (s) => {
  const map: { [index: number]: Specialization } = {};
  s.reduce((a, c) => {
    a[c.specializationId] = c;
    return a;
  }, map);

  return map;
});


